import React from 'react';
import { Info, AlertCircle, AlertTriangle, CheckCircle } from 'lucide-react';
import Button from './Button';

const ICON_MAP = {
  success: CheckCircle,
  error:   AlertCircle,
  warning: AlertTriangle,
  info:    Info,
};

const STYLE_MAP = {
  success: {
    bg:        'rgba(63, 239, 166, 0.08)',
    border:    'rgba(63, 239, 166, 0.25)',
    iconColor: 'var(--accent)',
    textColor: 'var(--text-body)',
  },
  error: {
    bg:        'rgba(239, 68, 68, 0.08)',
    border:    'rgba(239, 68, 68, 0.2)',
    iconColor: '#ef4444',
    textColor: 'var(--text-body)',
  },
  warning: {
    bg:        'rgba(234, 179, 8, 0.08)',
    border:    'rgba(234, 179, 8, 0.25)',
    iconColor: '#ca8a04',
    textColor: 'var(--text-body)',
  },
  info: {
    bg:        'rgba(37, 99, 235, 0.07)',
    border:    'rgba(37, 99, 235, 0.2)',
    iconColor: '#3b82f6',
    textColor: 'var(--text-body)',
  },
};

const Notice = ({ message, variant = 'info', actionText, onActionClick, className }) => {
  const IconComponent = ICON_MAP[variant] || ICON_MAP.info;
  const styles = STYLE_MAP[variant] || STYLE_MAP.info;

  return (
    <div
      className={`flex items-center gap-2.5 rounded-xl px-3 py-2.5 animate-fade-in ${className ?? ''}`}
      style={{
        background: styles.bg,
        border:     `1px solid ${styles.border}`,
      }}
    >
      <IconComponent
        style={{ width: '1rem', height: '1rem', flexShrink: 0, color: styles.iconColor }}
      />
      <p
        className='text-xs leading-relaxed flex-1'
        style={{ color: styles.textColor }}
      >
        {message}
      </p>
      {actionText && onActionClick && (
        <Button
          variant='text'
          size='xs'
          onClick={onActionClick}
          className='shrink-0 !p-0 text-xs'
          style={{ color: styles.iconColor }}
        >
          {actionText}
        </Button>
      )}
    </div>
  );
};

export default Notice;
